/**
 * 商品情報リスト取得リクエスト用VO
 *
 * @export RequestUpdateGoodsInfoModel
 * @class RequestUpdateGoodsInfoModel
 */
export class RequestUpdateGoodsInfoModel {
  /**
   *  コマID
   */
  public komaID = Number(0);

  /**
   * 表組パターンID
   */
  public listingPatternID = String('');

  /**
   * 表組商品Ｐコード
   */
  public listingPCode = String('');

  /**
   * コマコメント
   */
  public komaComment = String('');

  /**
   * コマパターン区分
   */
  public komaPatternDiv = String('');

  /**
   * 価値コマコメント
   */
  public valueKomaComment = '';

  /**
   * 商品情報リスト
   */
  public goodsInfoList: Array<any> = null;

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('');

  /**
   * 選択コマのPコードリスト
   */
  public pcodeList: Array<any> = new Array<any>();

  /**
   * 注文商品区分（コマ割画面遷移用）
   */
  public orderGoodsFlgKoma: Array<any> = new Array<any>();

  /**
   * 受注コード
   */
  public orderCode = '';

  /**
   * 媒体区分
   */
  public mediumType = '';

  /**
   * クロスコード
   */
  public crossCode = '';

  /**
   * クロス設定商品説明文
   */
  public crossGoodsExplanation = '';

  /**
   * クロス設定キャッチコピー
   */
  public crossCatchCopy = '';

  /**
   * マルチコード
   */
  public multiCode = '';

  /**
   * マルチ設定商品説明文
   */
  public multiGoodsExplanation = '';

  /**
   * マルチ設定キャッチコピー
   */
  public multiCatchCopy = '';
}
